export default __webpack_public_path__ + "static/media/icon3.b5fdb9e9.svg";